import styled from 'styled-components';
import { ReactComponent as MapMarker } from '../../../../images/map-marker.svg';
import { Icon as IconComponent } from '../../../../shared/components/icon';
import { themeColor } from '../../../../theme/getters';

export const Container = styled.div``;

export const Marker = styled(MapMarker)`
  display: inline-block;
  width: 55px;
  height: 60px;
`;

export const Icon = styled(IconComponent)`
  color: ${themeColor('white')};
  position: absolute;
  top: 7px;
  left: 10px;
`;
